module.exports = "pegasus_template/assets/preview-1.png";